import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=ef7228fa&scoped=true&"
import script from "./WechatLogin.vue?vue&type=script&lang=js&"
export * from "./WechatLogin.vue?vue&type=script&lang=js&"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=ef7228fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7228fa",
  null
  
)

export default component.exports